import React, { useContext } from "react"
import { ParticipantsContext } from "~/components/twilio/ParticipantsProvider"
import styled from "styled-components"
import { VideoContext } from "~/components/twilio/VideoProvider"

const OuterContainer = styled.div`
  width: 2em;
  height: 2em;
  padding: 0.9em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`

const InnerContainer = styled.div`
  display: flex;
  align-items: flex-end;

  & div {
    width: 2px;
    margin-right: 1px;

    &:not(:last-child) {
      border-right: none;
    }
  }
`

const STEP = 3
const BARS_ARRAY = [0, 1, 2, 3, 4]

export default function NetworkQualityLevel({ userId }: { userId: number }) {
  const { client } = useContext(VideoContext)
  const { networkQualities } = useContext(ParticipantsContext)
  const quality = networkQualities[userId]
  const currentUserId = client?.getCurrentUserInfo()?.userId
  // HungHV: default value is 5, because when no one joins the room,
  // check did not receive any event about network quality, it seems zoom has not processed data transmission so there is no event
  let level = 5

  if (userId === currentUserId) {
    level = quality?.uplink || 5
  } else {
    level = quality?.downlink || 5
  }

  return (
    <OuterContainer>
      <InnerContainer>
        {BARS_ARRAY.map((bar) => (
          <div
            key={bar}
            style={{
              height: `${STEP * (bar + 1)}px`,
              background: level > bar ? "green" : "rgba(255, 255, 255, 0.2)",
            }}
          />
        ))}
      </InnerContainer>
    </OuterContainer>
  )
}
